/* eslint-disable max-lines */
import {
    PolicyIdVo,
    QuerySpuParam3,
    QueryRestrictDistributionSpuResultVo,
    QuerySpuParam2,
    QueryErpSpuParam2,
    QueryRestrictDistributionErpSpuResultVo,
    QueryErpSpuParam,
    QuerySkuParam1,
    QueryRestrictDistributionSkuResultVo,
    QuerySkuParam,
    RestrictDistributionPolicy,
    Progress,
    SavePolicyParam,
    SavePolicyTip,
    UpdateEnabledStatusParam,
    PolicyVo1,
    SaveSpuParam,
    SaveChannelParam,
    RestrictDistributionUserCategory,
    RestrictDistributionLabel,
    RestrictDistributionChannelLabel,
    RestrictDistributionBrand,
    QuerySpuParam4,
    QueryErpSpuParam3,
    DrpItemCanDistributedVo,
    ItemCanDistributedResult,
    GoodsCanSeeParam,
    GoodsCanSeeResult,
    QuerySpuStyleCodeAndNameAndSkuUsingGetParams,
    StyleAndNameSpu,
    DrpItemPriceCanDistributedParam,
    ItemPriceCanDistributedResult,
    QueryErpSkuParamV2,
    QueryRestrictDistributionSkuResultVoV2,
    QueryPolicyListVo,
    QueryErpSpuParam1,
    SaveSkuParam,
    PolicyCodeCheckVo,
    PolicyCodeCheckResultVo,
    QueryChannelParam,
    MyPartnerVo,
    BatchAddErpLabelParam,
    QueryPolicyLogParam,
    RestrictDistributionPolicyLog,
    QueryPolicyLogDetailParam,
    QueryInventoryDetailParam,
    ListItemCodesByStyleCodeUsingGetParams,
    PlatformItemSpecQueryParam,
    ItemCodeAndSpecSku,
    ShopItemSpecQueryParam,
    ShopItemSkuVo
} from '@servicesTypings/goodsRequest'
import {
    QueryMyPartnerForRestrictDistributionUsingGet1Params,
    MyPartnerForRestrictDistribution,
    CoConfig,
    QueryMyPartnerForDrpItemRuleUsingGet1Params,
    MyChannelOptionsUsingGet1Params,
    MyChannelOptions
} from '@servicesTypings/drpRequest'
import { SimulateLcsRuleParam, SimulateLcsRuleVo } from '@servicesTypings/companyRequest'
import { goodsRequest, companyRequest, drpRequest } from '@/utils/request'

// 创建临时策略
export function createPolicy() {
    return goodsRequest.get('/restrictDistribution/createPolicy')
}

// 查询合作中的分销商
/**
 * 查询合作中的分销商(限制分销用)
 */
export function queryMyPartnerDistributor(
    params: QueryMyPartnerForRestrictDistributionUsingGet1Params
): API.Res<MyPartnerForRestrictDistribution[]> {
    return drpRequest.get('/myPartner/queryMyPartnerForRestrictDistribution', { params })
}

// 设置分销策略中我的分销商
/**
 * swagger找不到此接口
 */
export function saveChannelCache(data) {
    return goodsRequest.post('/restrictDistributionCache/saveChannelCache', {
        data
    })
}

// 查询策略中分销商列表
/**
 * swagger找不到此接口
 */
export function queryChannelCache(data) {
    return goodsRequest.post('/restrictDistributionCache/queryChannelCache', {
        data
    })
}

//  查询策略中分销商列表数量
/**
 * 查询分销商缓存数量
 */
export function queryChannelCacheNum(data: PolicyIdVo): API.Res<number> {
    return goodsRequest.post('/restrictDistributionCache/queryChannelCacheNum', { data })
}

// 删除分销商缓存
/**
 * 删除分销商缓存
 */
export function removeChannelCache(data: string): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/removeChannelCache', { data })
}

// 查询全部spu
/**
 * 查询全部SPU
 */
export function queryAllSpu(data: QuerySpuParam3): API.Res<QueryRestrictDistributionSpuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/queryAllSpu', { data })
}

// 查询缓存spu
/**
 * 查询SPU缓存
 */
export function querySpuCache(data: QuerySpuParam2): API.Res<QueryRestrictDistributionSpuResultVo[]> {
    return goodsRequest.post('/restrictDistributionCache/querySpuCache', { data })
}

// 删除spu缓存
/**
 * 删除SPU缓存
 */
export function removeSpuCache(data: string): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/removeSpuCache', { data })
}

// 查询全部spu
/**
 * 查询所有ErpSpuV2
 */
export function queryErpSpuPage(data: QueryErpSpuParam2): API.Res<QueryRestrictDistributionErpSpuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/queryAllErpSpuV2', { data })
}

// 查询是否超过数据
/**
 * 是否商品大数据量商家
 */
export function lotsOfRowCompany(): API.Res<boolean> {
    return goodsRequest.get('/statistics/lotsOfRowCompany')
}

// 查询ErpSPU缓存
/**
 * 查询ErpSPU缓存V2
 */
export function queryErpSpuCache(data: QueryErpSpuParam): API.Res<QueryRestrictDistributionErpSpuResultVo[]> {
    return goodsRequest.post('/restrictDistributionCache/queryErpSpuCacheV2', { data })
}

// 查询数量
/**
 * 查询ErpSpu缓存数量
 */
export function queryErpSpuCacheNum(data: PolicyIdVo): API.Res<number> {
    return goodsRequest.post('/restrictDistributionCache/queryErpSpuCacheNum', { data })
}

// 查询全部sku
/**
 * 查询全部SKU
 */
export function queryAllSku(data: QuerySkuParam1): API.Res<QueryRestrictDistributionSkuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/queryAllSku', { data })
}

// 查询缓存sku
/**
 * 查询SKU缓存
 */
export function querySkuCache(data: QuerySkuParam): API.Res<QueryRestrictDistributionSkuResultVo[]> {
    return goodsRequest.post('/restrictDistributionCache/querySkuCache', { data })
}

// 查询策略列表
/**
 * 查询策略列表
 */
export function queryPolicy(): API.Res<RestrictDistributionPolicy[]> {
    return goodsRequest.get('/restrictDistribution/queryPolicy')
}

// 删除策略
/**
 * 删除策略
 */
export function removePolicy(data: PolicyIdVo): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/removePolicy', { data })
}

// 同步ERP策略
/**
 * 同步ERP策略
 */
export function syncErpItemRule(): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/syncErpItemRule')
}

// 查询同步进度
/**
 * 获取同步进度
 */
export function querySyncProgress(): API.Res<Progress> {
    return goodsRequest.get('/restrictDistribution/getSyncProgress')
}

// 查询策略明细
/**
 * 编辑策略
 */
export function queryPolicyInfo(data: PolicyIdVo): API.Res<RestrictDistributionPolicy> {
    return goodsRequest.post('/restrictDistribution/editPolicy', { data })
}

// 保存策略
/**
 * 保存策略
 */
export function savePolicy(data: SavePolicyParam): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/savePolicy', { data })
}

// 保存策略前判断重复
/**
 * 保存策略提示
 */
export function savePolicyTip(data: SavePolicyParam): API.Res<SavePolicyTip> {
    return goodsRequest.post('/restrictDistribution/savePolicyTip', { data })
}

// 修改策略启用状态
/**
 * 修改启用状态
 */
export function updateEnabledStatus(data: UpdateEnabledStatusParam): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/updateEnabledStatus', { data })
}

// 查询全部策略
/**
 * 查询全部策略
 */
export function queryAllPolicy(): API.Res<PolicyVo1[]> {
    return goodsRequest.get('/restrictDistribution/queryAllPolicy')
}

// 保存spu至策略
/**
 * 保存SPU
 */
export function saveSpuToPolicy(data: SaveSpuParam): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/saveSpu', { data })
}

// 保存channelCoIdList至策略
/**
 * 向当前规则追加分销商
 */
export function addChannelsToPolicy(data: SaveChannelParam): API.Res<object> {
    return goodsRequest.post('/restrictDistribution/addChannels', { data })
}

// 查询展架分类
/**
 * 查询展架分类
 */
export function queryUserCategory(data: PolicyIdVo): API.Res<RestrictDistributionUserCategory[]> {
    return goodsRequest.post('/restrictDistribution/queryUserCategory', { data })
}

// 查询ERP标签
/**
 * 查询ERP标签
 */
export function queryLabel(data: PolicyIdVo): API.Res<RestrictDistributionLabel[]> {
    return goodsRequest.post('/restrictDistribution/queryLabel', { data })
}

// 分销商标
/**
 * 查询分销商标签
 */
export function queryChannelLabel(data: PolicyIdVo): API.Res<RestrictDistributionChannelLabel[]> {
    return goodsRequest.post('/restrictDistribution/queryChannelLabel', { data })
}

// 查询ERP品牌
/**
 * 查询ERP品牌
 */
export function queryBrand(data: PolicyIdVo): API.Res<RestrictDistributionBrand[]> {
    return goodsRequest.post('/restrictDistribution/queryBrand', { data })
}

// 查询已保存spu
/**
 * 查询已保存SPU
 */
export function querySpu(data: QuerySpuParam4): API.Res<QueryRestrictDistributionSpuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/querySpu', { data })
}

// 查询已保存spu
/**
 * 查询已保存ErpSpuV2
 */
export function queryErpSpu(data: QueryErpSpuParam3): API.Res<QueryRestrictDistributionErpSpuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/queryErpSpuV2', { data })
}

// 查询已保存sku
/**
 * 查询已保存SKU
 */
export function querySku(data: QuerySkuParam1): API.Res<QueryRestrictDistributionSkuResultVo[]> {
    return goodsRequest.post('/restrictDistribution/querySku', { data })
}

// 分销提示
/**
 * 设置是否显示限制分销提示
 */
export function closeDistributionTip(data: CoConfig): API.Res<object> {
    return drpRequest.post('/config/updateShowRestrictDistributionTips', { data })
}

// 分销商是否可见
/**
 * 商品分销商是否可见
 */
export function queryItemCanDrp(data: DrpItemCanDistributedVo): API.Res<ItemCanDistributedResult[]> {
    return goodsRequest.post('/drpItemRule/queryItemCanDrp', { data })
}

// 分销小站是否可见
/**
 * 商品在分销小站是否可见
 */
export function queryItemCanSee(data: GoodsCanSeeParam): API.Res<GoodsCanSeeResult[]> {
    return goodsRequest.post('/drpItemRule/queryItemCanSee', { data })
}

// 查询合作中分销商
/**
 * 查询合作中的分销商(分销限定策略用)
 */
export function queryMyPartnerForDrpItemRule(
    params: QueryMyPartnerForDrpItemRuleUsingGet1Params
): API.Res<MyPartnerForRestrictDistribution[]> {
    return drpRequest.get('/myPartner/queryMyPartnerForDrpItemRule', { params })
}

// 查询商品的资料编码与名称与SKU信息
/**
 * 查询商品的资料编码与名称与SKU信息
 */
export function querySpuStyleCodeAndNameAndSku(
    params: QuerySpuStyleCodeAndNameAndSkuUsingGetParams
): API.Res<StyleAndNameSpu> {
    return goodsRequest.get('/goods/querySpuStyleCodeAndNameAndSku', { params })
}

// 商品分销价格是否可见
/**
 * 商品分销价格是否可见
 */
export function queryItemPriceCanDrp(data: DrpItemPriceCanDistributedParam): API.Res<ItemPriceCanDistributedResult[]> {
    return goodsRequest.post('/drpItemRule/queryItemPriceCanDrp', { data })
}

// 查询是否是需要提示融合规则弹窗的用户
/**
 * 是否需要提示erp单边规则融合信息
 */
export function needMergeTips(): API.Res<boolean> {
    return goodsRequest.get('/drpItemRule/needMergeTips')
}

// 查询是否是需要提示融合规则弹窗的用户(供应链)
/**
 * 是否需要提示分销版单边规则融合信息
 */
export function needGylMergeTips(): API.Res<boolean> {
    return goodsRequest.get('/drpItemRule/needGylMergeTips')
}

// 查询是否是需要提示融合规则弹窗的用户(供应链)
/**
 * 是否需要提示双边规则融合信息
 */
export function needBilateralMergeTips(): API.Res<boolean> {
    return goodsRequest.get('/drpItemRule/needBilateralMergeTips')
}

// 查询全部ErpSkuV2
/**
 * 查询全部ErpSkuV2
 */
export function queryAllErpSkuV2(data: QueryErpSkuParamV2): API.Res<QueryRestrictDistributionSkuResultVoV2[]> {
    return goodsRequest.post('/restrictDistribution/queryAllErpSkuV2', { data })
}

// 查询已保存ErpSkuV2
/**
 * 查询已保存ErpSkuV2
 */
export function queryErpSkuV2(data: QueryErpSkuParamV2): API.Res<QueryRestrictDistributionSkuResultVoV2[]> {
    return goodsRequest.post('/restrictDistribution/queryErpSkuV2', { data })
}

// 查询ErpSkU缓存V2
/**
 * 查询ErpSkU缓存V2
 */
export function queryErpSkuCacheV2(data: QueryErpSkuParamV2): API.Res<QueryRestrictDistributionSkuResultVoV2[]> {
    return goodsRequest.post('/restrictDistributionCache/queryErpSkuCacheV2', { data })
}

// 查询缓存数量
/**
 * 查询ErpSkU缓存数量
 */
export function queryErpSkuCacheNum(data: PolicyIdVo): API.Res<number> {
    return goodsRequest.post('/restrictDistributionCache/queryErpSkuCacheNum', { data })
}

// 查询分销策略
/**
 * 查询策略列表
 */
export function queryMergePolicy(data: QueryPolicyListVo): API.Res<RestrictDistributionPolicy[]> {
    return goodsRequest.post('/restrictDistribution/policyList', { data })
}

// 查询已选资料编码【已选商品】
/**
 * 查询已选的Gyl资料编码
 */
export function queryGylStyleCodeCache(data: QuerySpuParam3): API.Res<string[]> {
    return goodsRequest.post('/restrictDistributionCache/queryGylStyleCodeCache', { data })
}

// 保存选择的Gyl资料编码【已选商品】
/**
 * 保存选择的Gyl资料编码
 */
export function saveGylStyleCodeCache(data: SaveSpuParam): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/saveGylStyleCodeCache', { data })
}

// 查询Erp已选款式编码【已选商品】
/**
 * 查询Erp已选款式编码
 */
export function queryErpStyleCodeCache(data: QueryErpSpuParam1): API.Res<string[]> {
    return goodsRequest.post('/restrictDistributionCache/queryErpStyleCodeCache', { data })
}

// 保存选择的Erp资料编码【已选商品】
/**
 * 保存选择的Erp款式编码
 */
export function saveErpStyleCodeCache(data: SaveSpuParam): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/saveErpStyleCodeCache', { data })
}

// 查询已选商品编码【已选商品】
/**
 * 查询Erp已选商品编码
 */
export function queryErpItemCodeCache(data: QueryErpSkuParamV2): API.Res<string[]> {
    return goodsRequest.post('/restrictDistributionCache/queryErpItemCodeCache', { data })
}

// 保存选择的Erp商品编码【已选商品】
/**
 * 保存选择的Erp商品编码
 */
export function saveErpItemCodeCache(data: SaveSkuParam): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/saveErpItemCodeCache', { data })
}

// 校验失效的资料编码列表【选商品】
/**
 * 校验失效的资料编码列表
 */
export function invalidStyleCodes(data: PolicyCodeCheckVo): API.Res<PolicyCodeCheckResultVo> {
    return goodsRequest.post('/restrictDistribution/invalidStyleCodes', { data })
}

// 校验失效的erp款式编码列表【选商品】
/**
 * 校验失效的商品编码列表
 */
export function invalidIids(data: PolicyCodeCheckVo): API.Res<PolicyCodeCheckResultVo> {
    return goodsRequest.post('/restrictDistribution/invalidIids', { data })
}

// 校验失效的商品编码列表【选商品】
/**
 * 校验失效的商品编码列表
 */
export function invalidItemCodes(data: PolicyCodeCheckVo): API.Res<PolicyCodeCheckResultVo> {
    return goodsRequest.post('/restrictDistribution/invalidItemCodes', { data })
}

// 添加编辑分销商统一【查询策略中分销商列表】
/**
 * 查询分销商缓存列表V2
 */
export function queryChannelCacheV2(data: QueryChannelParam): API.Res<MyPartnerVo[]> {
    return goodsRequest.post('/restrictDistributionCache/queryChannelCacheV2', { data })
}

// 添加编辑分销商统一【设置分销策略中我的分销商】
/**
 * 保存分销商缓存V2
 */
export function saveChannelCacheV2(data: SaveChannelParam): API.Res<object> {
    return goodsRequest.post('/restrictDistributionCache/saveChannelCacheV2', { data })
}

// 添加编辑分销商统一【查询已保存分销商】
/**
 * 查询已保存分销商V2
 */
export function queryChannelV2(data: QueryChannelParam): API.Res<MyPartnerForRestrictDistribution[]> {
    return goodsRequest.post('/restrictDistribution/queryChannelV2', { data })
}

//  添加编辑分销商统一【查询分销商COID缓存】
/**
 * 查询分销商COID缓存
 */
export function queryChannelCoIdCache(data: PolicyIdVo): API.Res<string[]> {
    return goodsRequest.post('/restrictDistributionCache/queryChannelCoIdCache', { data })
}

//  批量为选中的商品编码添加ERP标签
/**
 * 批量为选中的商品编码添加ERP标签
 */
export function batchAddErpLabelByItemCodeList(data: BatchAddErpLabelParam): API.Res<string> {
    return goodsRequest.post('/restrictDistribution/batchAddErpLabelByItemCodeList', { data })
}

//  查询商家支持的最大模糊查询sku数量
/**
 * 商家支持的最大模糊查询sku数量
 */
export function itemSkuMaxLikeCount(): API.Res<number> {
    return goodsRequest.get('/statistics/itemSkuMaxLikeCount')
}

//  查询我的分销商
/**
 * 查询我的分销商
 */
export function myChannelOptions(params: MyChannelOptionsUsingGet1Params): API.Res<MyChannelOptions[]> {
    return drpRequest.get('/myPartner/myChannelOptions', { params })
}

// 查询订单快递匹配情况（由于快递未命中，导致推单失败，查询原因）
/**
 * 查询订单快递匹配情况（由于快递未命中，导致推单失败，查询原因）
 */
export function queryOrderSimulateLcsRule(data: SimulateLcsRuleParam): API.Res<SimulateLcsRuleVo[]> {
    return companyRequest.post('/order/simulateLcsRule', { data })
}

// 查询分销规则修改日志
/**
 * 查询分销规则修改日志列表
 */
export function queryPolicyLogList(data: QueryPolicyLogParam): API.Res<RestrictDistributionPolicyLog[]> {
    return goodsRequest.post('/restrictDistribution/queryPolicyLogList', { data })
}

// 查询分销规则修改日志详情
/**
 * 查询分销规则修改日志详情
 */
export function queryPolicyLogDetail(data: QueryPolicyLogDetailParam): API.Res<RestrictDistributionPolicyLog> {
    return goodsRequest.post('/restrictDistribution/queryPolicyLogDetail', { data })
}

//  查询单个策略的商品编码个数限制
/**
 * 查询单个策略的商品编码个数限制
 */
export function queryPolicyItemCodeLimit(): API.Res<number> {
    return goodsRequest.get('/restrictDistribution/queryPolicyItemCodeLimit')
}

// 获取同步库存处理明细
/**
 * 获取同步库存处理明细
 */
export function queryInventoryDetail(data: QueryInventoryDetailParam): API.Res<Record<string, object>> {
    return goodsRequest.post('/drpItemRule/queryInventoryDetail', { data })
}

// 根据资料编码查询商品编码列表
/**
 * 根据资料编码查询商品编码列表
 */
export function listItemCodesByStyleCode(params: ListItemCodesByStyleCodeUsingGetParams): API.Res<string[]> {
    return goodsRequest.get('/goodsQuery/listItemCodesByStyleCode', { params })
}

// 中台 查询平台资料规格列表
/**
 * 平台资料商品规格列表
 */
export function queryPlatformItemSpec(data: PlatformItemSpecQueryParam): API.Res<ItemCodeAndSpecSku[]> {
    return goodsRequest.post('/op/freshman/queryPlatformItemSpec', { data })
}

// 中台 查询店铺商品规格列表
/**
 * 查询店铺商品规格列表
 */
export function queryShopItemSpec(data: ShopItemSpecQueryParam): API.Res<ShopItemSkuVo[]> {
    return goodsRequest.post('/op/freshman/queryShopItemSpec', { data })
}

/** 查询分销商 coId 接口参数 */
export interface QueryChannelCoIdParams {
    /** 分销规则 ID */
    policyId: string
}

/** 查询分销商 coId */
export function queryChannelCoId(params: QueryChannelCoIdParams): API.Res<string[]> {
    return goodsRequest.get('/restrictDistribution/queryChannelCoId', { params })
}

/** 查询分销商参数 */
export interface QueryChannelParamV3 {
    /** 缓存ID */
    cacheId?: string

    /** 分销商 coId 数组 */
    channelCoIds?: string[]

    /** 分销商名称数组 */
    channelCoNames?: string[]

    /** 分销等级 */
    disLevel?: string

    /** 当前页(分页参数) */
    pageNum?: number

    /** 每页条数(分页参数) */
    pageSize?: number

    /** 策略ID */
    policyId?: string

    /** 分销商名称模糊搜索 */
    vagueSearch?: string
}

/** 分销商信息 */
// export interface MyPartnerForRestrictDistribution {
//     /** 分销商coId */
//     channelCoId: string

//     /** 分销商ERP名称 */
//     coName: string

//     /** 分销商名称 */
//     companyName: string

//     /** 分销等级 */
//     disLevel: string

//     /** @deprecated 分销商手机号 (不再返回该字段信息) */
//     phone: string

//     /** 同步供应商控价 */
//     syncRegulatePrice: boolean
// }

/** 查询已保存分销商V3 */
export function queryOptionsNoAuth(data: QueryChannelParamV3): API.Res<MyPartnerForRestrictDistribution[]> {
    return drpRequest.post('/myChannel/queryOptionsNoAuth', { data })
}

/** 查询分销商缓存列表V3 */
export function queryChannelCacheV3(data: QueryChannelParamV3): API.Res<MyPartnerForRestrictDistribution[]> {
    return goodsRequest.post('/restrictDistributionCache/queryChannelCacheV3', { data })
}

/** 保存分销商缓存V3 */
export function saveChannelCacheV3(data: QueryChannelParamV3): API.Res<boolean> {
    return goodsRequest.post('/restrictDistributionCache/saveChannelCacheV3Condition', { data })
}
